export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtPPservisnr';
export const NAME = 'PpServisniCislo';
